import DesignTokens from '@tableau/design-tokens';
import { TabStyles } from '@tableau/widgets';

import { cssClass } from '~src/style';

const cssPrefix = 'ImportBundleDialog';
const BORDER = `${TabStyles.Sizing.BorderWidth}px solid ${DesignTokens.color.elevation.border.default.default}`;

export namespace ImportBundleDialogStyles {
  /** Centered column for the loading / cancelling (spinner + message) and result phases. */
  export const StatusState = cssClass(cssPrefix, 'status-state', {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: `${TabStyles.Spacing.ExtraLargeSpace}px 0`,
  });

  export const StatusMessage = cssClass(cssPrefix, 'status-message', {
    marginTop: TabStyles.Spacing.MediumSpace,
    color: DesignTokens.color.font.default.default,
  });

  export const Intro = cssClass(cssPrefix, 'intro', {
    marginBottom: TabStyles.Spacing.MediumSpace,
  });

  /** Spacing below an inline alert. */
  export const Alert = cssClass(cssPrefix, 'alert', {
    marginBottom: TabStyles.Spacing.MediumSpace,
  });

  export const ItemList = cssClass(cssPrefix, 'item-list', {
    maxHeight: 320,
    overflowY: 'auto',
    border: BORDER,
    borderRadius: TabStyles.Sizing.BorderRadius,
  });

  export const ItemRow = cssClass(cssPrefix, 'item-row', {
    display: 'flex',
    alignItems: 'center',
    padding: `${TabStyles.Spacing.DefaultSpace}px ${TabStyles.Spacing.MediumSpace}px`,
    borderTop: BORDER,
    $nest: { '&:first-child': { borderTop: 'none' } },
  });

  export const ItemText = cssClass(cssPrefix, 'item-text', {
    flex: '1 1 auto',
    minWidth: 0,
    marginLeft: TabStyles.Spacing.DefaultSpace,
  });

  export const ItemName = cssClass(cssPrefix, 'item-name', {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  });

  export const ItemDetail = cssClass(cssPrefix, 'item-detail', {
    color: DesignTokens.color.font.default.secondary,
    fontSize: TabStyles.Typography.Sizing.Small,
  });

  /** An item that will overwrite (or failed to import) is flagged in the warning / error color. */
  export const ItemDetailWarning = cssClass(cssPrefix, 'item-detail-warning', {
    color: DesignTokens.color.feedback.default.warning_dark,
  });

  export const ItemDetailError = cssClass(cssPrefix, 'item-detail-error', {
    color: DesignTokens.color.font.default.error,
  });

  export const SelectAll = cssClass(cssPrefix, 'select-all', {
    marginBottom: TabStyles.Spacing.DefaultSpace,
  });

  export const Summary = cssClass(cssPrefix, 'summary', {
    marginTop: TabStyles.Spacing.DefaultSpace,
    color: DesignTokens.color.font.default.secondary,
  });

  export const Confirm = cssClass(cssPrefix, 'confirm', {
    marginTop: TabStyles.Spacing.MediumSpace,
  });

  export const ProgressBar = cssClass(cssPrefix, 'progress-bar', {
    width: '100%',
  });

  /** Manifest summary line and the Show details / Show more links under it. */
  export const ManifestSummary = cssClass(cssPrefix, 'manifest-summary', {
    marginTop: TabStyles.Spacing.MediumSpace,
    color: DesignTokens.color.font.default.secondary,
  });

  export const ManifestActions = cssClass(cssPrefix, 'manifest-actions', {
    display: 'flex',
    justifyContent: 'center',
    marginTop: TabStyles.Spacing.DefaultSpace,
  });

  export const Details = cssClass(cssPrefix, 'details', {
    marginTop: TabStyles.Spacing.MediumSpace,
    textAlign: 'left',
    width: '100%',
  });
}
